import OrderList from './List';

const OrderIndex = {
  OrderList
};

export default OrderIndex;
